import { useState } from 'react';
import { Warning } from './Warning';
import { registerProfile, useApp } from '../store';
import { Loader } from './Loader';
import { useTranslation } from 'react-i18next';

export function Register() {
  const { t } = useTranslation();
  const { state, dispatch } = useApp();
  const [warning, setWarning] = useState<string[]>([]);
  const [name, setName] = useState('');

  const handleRegister = () => {
    if (name === '') {
      setWarning([t('warningNameRequired')]);
    } else {
      registerProfile({ name }, dispatch);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleRegister();
    }
  };

  if (state.loading) {
    return <Loader />;
  }

  return (
    <>
      <Warning message={warning} />
      <p>{t('registerText')}.</p>
      <input
        type="text"
        className={'name'}
        placeholder={t('registerNameInput')}
        value={name}
        id={'name'}
        onChange={(e) => {
          setName(e.target.value);
          setWarning([]);
        }}
        onKeyDown={handleKeyDown}
        autoFocus
      />

      <button className="primary" onClick={() => handleRegister()}>
        {t('registerButton')}
      </button>
    </>
  );
}
